import Styled from 'styled-components';

export const Container = Styled.section`
  border-radius: 8px;
  padding: 24px 0;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = Styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionTitle = Styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0;
`;

export const Details = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = Styled.div`
  display: grid;
  grid-template-columns: 220px 1fr;
  align-items: start;
  column-gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 150px 1fr;
  }
`;

export const ColLabel = Styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--primary-color);
  opacity: 0.8;
  text-transform: uppercase;
`;

export const ColValue = Styled.span`
  font-size: 14px;
  font-weight: 400;
  color: var(--primary-color);
`;

export const ColValueName = Styled.span`
  font-size: 14px;
  font-weight: 400;
  color: var(--primary-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Divider = Styled.hr`
  border: none;
  border-top: 1px solid #D7D7DB;
  margin: 8px 0 4px;
`;



